import { DOC_FLOW_RESULT_ENTITY } from '../../../constants/entity'
import { PageLoader } from '../../Page'
import { DOC_FLOW_TABLE_ACTIONS_COLUMN_WIDTH } from '../DocFlow.constants'
import { useResultPhase } from '../DocFlow.hooks'
import { DocFlowPhaseTable } from '../DocFlowPhaseTable'
import { DocFlowResultTableRow } from '../DocFlowResultTableRow'

import { updateResultTableConfig } from './DocFlowResult.api'
import { getResultTableFilterApi } from './DocFlowResult.utils'

function DocFlowResult() {
  const { handleClickResendEpost, isPageLoader, tableData } = useResultPhase()

  const { isRefetching, permissions } = tableData

  return (
    <>
      {isRefetching || isPageLoader ? <PageLoader /> : null}
      <DocFlowPhaseTable
        TableRow={DocFlowResultTableRow}
        emptyStateText='DocumentStapling.ResultTableNoDataKey'
        entity={DOC_FLOW_RESULT_ENTITY}
        getFilterApi={getResultTableFilterApi}
        tableLoader={tableData}
        tableProps={{
          actionsColumnWidth: DOC_FLOW_TABLE_ACTIONS_COLUMN_WIDTH,
        }}
        tableRowProps={{ permissions, onEpostResend: handleClickResendEpost }}
        updateTableConfig={updateResultTableConfig}
      />
    </>
  )
}

export default DocFlowResult
